import cn from 'classnames/bind'

import OveflowedText from 'app/common/components/OveflowedText'
import Link from 'app/common/lib/link'

import styles from './cell-content-array.module.scss'

const cx = cn.bind(styles)

type Props = {
  items: Array<{ ID: string; title: string }>
  className?: string
  links?: Array<string>
}

export const CellContentArray = ({ items, className, links }: Props) => {
  return (
    <ul className={cx(styles.root, className)}>
      {items.map(({ ID, title }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={ID + title + index}>
          <OveflowedText>
            {links ? (
              <Link className={styles.link} to={links[index]}>
                {title}
              </Link>
            ) : (
              title
            )}
          </OveflowedText>
        </li>
      ))}
    </ul>
  )
}
